// providers/myCase.ts
import * as Api from '@ViewModels';
import { ATTORNEY_TAG_OPTIONS } from './constants';
import { provider, providerTag, select } from './helpers';

export const myCaseConfig = provider(Api.IntegrationProvider.MyCase, {
	displayName: 'MyCase',

	main: {
		writebacks: true,
	},

	keyFacts: {
		birthdayDisplay: true,
	},

	tags: {
		coreTags: true,
		customFields: true,
		providerTags: [
			providerTag('GroupPracticeArea', 'Group Practice Area'),
			providerTag('PeopleGroup', 'People Group'),
			providerTag('CaseNumber', 'Case Number'),
			providerTag('CaseName', 'Case Name'),
		],
		extraFields: [
			select('leadAttorneyTag', ATTORNEY_TAG_OPTIONS, {
				label: 'Lead Attorney Tag Options',
				subtitle: 'Control how lead attorney information is tagged on contacts',
				placeholder: 'Select lead attorney tag options',
			}),
			select('originatingAttorneyTag', ATTORNEY_TAG_OPTIONS, {
				label: 'Originating Attorney Tag Options',
				subtitle: 'Control how originating attorney information is tagged on contacts',
				placeholder: 'Select originating attorney tag options',
			}),
		],
	},
});
